export enum actionTypes {
    ADD_TAGS = 'ADD_TAGS',
    APP_FETCH = 'APP_FETCH',
    SET_RG_CONFIG = 'SET_RG_CONFIG',
    TOGGLE_RECONNECT = 'TOGGLE_RECONNECT',
    UPDATE_GAMES_DATA = 'UPDATE_GAMES_DATA',
    UPDATE_MENU_ITEMS = 'UPDATE_MENU_ITEMS',
    SET_FAVORITE_GAMES = 'SET_FAVORITE_GAMES',
    UPDATE_HEADER_HEIGHT = 'UPDATE_HEADER_HEIGHT',
    UPDATE_FAVORITE_GAMES = 'UPDATE_FAVORITE_GAMES',
    TOGGLE_IS_APP_INIT_EXECUTED = 'TOGGLE_IS_APP_INIT_EXECUTED',
    SET_IS_QUICK_DEPOSIT_AVAILABLE = 'SET_IS_QUICK_DEPOSIT_AVAILABLE'
}
